import { useEffect, useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { State } from "../../redux";

import { ColorV2, Text } from "@adoptaunabuelo/react-components";
import RightSectionContainer from "../../components/container/RightSectionContainer";
import NumberIcon from "../../assets/images/icon/Number";

const CellContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	margin-top: 32px;
`;
const Cell = styled.div`
	display: flex;
	flex-direction: row;
	gap: 12px;
`;
const Col = styled.div`
	display: flex;
	flex-direction: column;
`;

const SuccessRight = (props: Props) => {
	const isMobile: boolean = useSelector(
		(state: State) => state.screen.isMobile
	);

	const [animation, setAnimation] = useState<string>("fadeOut");
	const data = [
		{
			img: (
				<NumberIcon
					type="1"
					color={ColorV2.text.neutralHard}
					height={24}
					width={24}
				/>
			),
			title: "Recibe tu Pack",
			subtitle:
				"¡Lo estamos preparando! Te enviaremos un email cuando lo enviemos.",
		},
		{
			img: (
				<NumberIcon
					type="2"
					color={ColorV2.text.neutralHard}
					height={24}
					width={24}
				/>
			),
			title: "Escribe tu carta",
			subtitle:
				"El momento más especial, ¡no olvides poner mucho cariño en tus palabras!",
		},
		{
			img: (
				<NumberIcon
					type="3"
					color={ColorV2.text.neutralHard}
					height={24}
					width={24}
				/>
			),
			title: "Envía tu carta a tiempo",
			subtitle:
				"Solo tienes que llevarla al buzón. Dentro del Pack encontrarás las instrucciones detalladas.",
		},
		{
			img: (
				<NumberIcon
					type="4"
					color={ColorV2.text.neutralHard}
					height={24}
					width={24}
				/>
			),
			title: "Nosotros nos encargaremos del resto",
			subtitle:
				"Le haremos llegar la carta a la persona mayor. ¡Seguro que le hace muchísima ilusión!",
		},
	];

	useEffect(() => {
		if (isMobile || !props.animationTime) setAnimation("fadeIn");
		else
			setTimeout(() => {
				setAnimation("fadeIn");
			}, props.animationTime * 1000);
	}, []);

	return (
		<RightSectionContainer
			style={
				isMobile
					? {
							margin: "0px -24px",
							padding: "32px 24px 16px",
							width: "unset",
							marginTop: 32,
					  }
					: {
							marginLeft: 32,
							marginTop: 24,
							width: animation === "fadeIn" ? 388 : 0,
							opacity: animation === "fadeIn" ? 1 : 0,
							transition:
								"width 0.5s ease-in-out, opacity 0.5s ease-in-out 0.3s",
					  }
			}
			dataContainerStyle={{ justifyContent: "flex-start" }}
		>
			<Text type="h3" weight="semibold">
				Estos son los próximos pasos para que tu carta llegue a su
				destino
			</Text>
			<CellContainer>
				{data.map((item, index) => (
					<Cell key={"steps-" + index}>
						{item.img}
						<Col style={{ flex: 1 }}>
							<Text type="h6" weight="medium">
								{item.title}
							</Text>
							<Text
								type="p2"
								style={{ color: ColorV2.text.neutralMedium }}
							>
								{item.subtitle}
							</Text>
						</Col>
					</Cell>
				))}
			</CellContainer>
		</RightSectionContainer>
	);
};
export default SuccessRight;
export interface Props {
	animationTime?: number;
}
